import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Yourorder = ({flower, CancelHandler}) => {
    return (
     <>
        <Row className='mt-4'>
            <Col lg={5} md={6} sm={12}>
                <img className='img-fluid' src={`data:image/jpeg;base64,${flower?.img}`} alt="" />
                <h4 className="my-4">{flower?.flowername}</h4>
            </Col>
            <Col className="d-flex align-items-center" lg={5} md={6} sm={12}>
               <div>
               <h5>Flower Amount: {flower?.floweramount}</h5>
                <h5>Amount: {flower?.singletotal}</h5>
                <h5>Delivery Date: {flower?.deliverydate}</h5>
                <h5>Status: {flower?.status === 'pending' ? <span className="text-primary">{flower?.status }</span> : <span className="text-danger">{flower?.status }</span>}</h5>
                {
                    flower?.status === 'canceled'? '' : <button onClick={() => CancelHandler(flower._id)} className='btn btn-dark text-warning fw-bold'>CANCEL ORDER</button>
                }
               </div>
            </Col>
        </Row>
        <hr />
     </>
    );
};

export default Yourorder;